<div class="w-full flex flex-col pt-5 gap-md">
  <div class="flex">
    <span class="text-4xl font-bold">
      {{ "MasterData.Sidebar.Countries" | i18nextEager }}
    </span>
  </div>
  <doka-search-field (valueChange)="searchText.set($event)" [placeholder]="'Common.Search' | i18nextEager" />

  @if (countries.isLoading()) {
    <app-spinner />
  } @else {
    <doka-table>
      <doka-thead>
        <doka-tr>
          <doka-th>
            {{ "MasterData.CountriesGrid.Code" | i18nextEager }}
          </doka-th>
          <doka-th>
            {{ "MasterData.CountriesGrid.Name" | i18nextEager }}
          </doka-th>
          <doka-th>
            {{ "MasterData.CountriesGrid.Division" | i18nextEager }}
          </doka-th>
          <doka-th>
            {{ "MasterData.CountriesGrid.MainCurrency" | i18nextEager }}
          </doka-th>
          <doka-th />
        </doka-tr>
      </doka-thead>
      <doka-tbody>
        @for (country of filteredCountries(); track country.id) {
          <doka-tr>
            <doka-td>{{ country.countryCode }}</doka-td>
            <doka-td>{{ country.countryName }}</doka-td>
            <doka-td>{{ country.divisionName }}</doka-td>
            <doka-td>{{ country.mainIsoCurrencyCode }}</doka-td>
            <doka-td>
              <div class="flex justify-end">
                @if (canEdit(country)) {
                  <a
                    class="action-icon"
                    [title]="'Common.Edit' | i18nextEager"
                    role="button"
                    (click)="editCountry(country)"
                  >
                    <doka-icon name="edit" />
                  </a>
                }
              </div>
            </doka-td>
          </doka-tr>
        }
      </doka-tbody>
    </doka-table>
  }
</div>
